/* Refuerzo: en escritorio la foto principal sigue siempre al color/talla elegido, sin recargar la ficha.
   Se apoya en window.__mfgGo (galeria-claude.js). No depende del orden de carga de galeria-sync-claude.js. */
(function () {
  'use strict';
  var TAG = 'mf-product-information';
  var DESK = window.matchMedia('(min-width: 990px)');
  function file(u) { return String(u || '').split('?')[0].split('/').pop(); }
  function sync(host) {
    if (!DESK.matches) return;
    var f = host.querySelector('[data-featured-media]');
    var id = f && f.dataset.featuredMedia;
    var go = window.__mfgGo;
    var wrap = host.querySelector('[data-gallery-wrap]');
    if (!id || typeof go !== 'function' || !wrap) return;
    var media = wrap.querySelector('.mf-media[data-media-id="' + id + '"]');
    var zoom = media && media.querySelector('[data-zoom-src]');
    if (!zoom) return;
    var key = file(zoom.dataset.zoomSrc);
    var thumbs = wrap.querySelectorAll('.mfg-thumb');
    for (var i = 0; i < thumbs.length; i++) {
      var im = thumbs[i].querySelector('img');
      if (im && file(im.getAttribute('src')) === key) { go(i); return; }
    }
  }
  function boot() {
    document.querySelectorAll(TAG).forEach(function (h) {
      if (h.__mfFix) return;
      h.__mfFix = true;
      h.addEventListener('change', function (e) {
        if (!(e.target && e.target.matches && e.target.matches('[data-option-value-id]'))) return;
        setTimeout(function () { sync(h); }, 0);
        setTimeout(function () { sync(h); }, 350);
      });
      new MutationObserver(function () { sync(h); }).observe(h, { attributes: true, attributeFilter: ['data-featured-media'], subtree: true });
    });
  }
  customElements.whenDefined(TAG).then(boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
